import { connect, MapDispatchToProps } from "react-redux";
import AddEditCourseComponent, {
  AddEditCourseProps,
} from "pages/Courses/AddEditCourse";
import {
  courseListRequest,
  addCourseRequest,
  editCourseRequest,
  deleteCourseRequest,
  courseByIdRequest,
  pendingCourseEnrollmentEducatorsRequest,
  courseMaterialListRequest,
  addCourseMaterialRequest,
  editCourseMaterialRequest,
  courseMaterialByIdRequest,
  deleteCourseMaterialRequest,
  getSCOListByCourseIdRequest,
} from "store/course/actions";
import {
  ICourseContainerDispatch,
  ICourse,
  ICourseMaterialContainerDispatch,
  ICourseMaterial,
} from "utils/interfaces/course";

type ICombinedDispatch = ICourseContainerDispatch &
  ICourseMaterialContainerDispatch;

const mapDispatchToProps: MapDispatchToProps<
  ICombinedDispatch,
  ICourse | ICourseMaterial
> = {
  courseListRequest,
  addCourseRequest,
  editCourseRequest,
  deleteCourseRequest,
  courseByIdRequest,
  pendingCourseEnrollmentEducatorsRequest,
  courseMaterialListRequest,
  addCourseMaterialRequest,
  editCourseMaterialRequest,
  courseMaterialByIdRequest,
  deleteCourseMaterialRequest,
  getSCOListByCourseIdRequest,
};

const connector = connect(null, mapDispatchToProps);

const AddEditCourse: React.FC<AddEditCourseProps> = (props) => {
  return <AddEditCourseComponent {...props} />;
};

export default connector(AddEditCourse);
